import React, { useMemo } from "react";

import Table from "src/components/Unifize/Table";
import { EmbeddedTableContainer, CellItem } from "../styles";
import Checkbox from "src/components/Unifize/Checkbox";

import type { AiLinkedFieldSuggestionValue } from "src/ts-types";

type Props = {
  disabled: boolean;
  values: AiLinkedFieldSuggestionValue["embeddedFields"];
  embeddedSelections: Set<number>;
  toggleEmbeddedSelection: (embeddedIndex: number) => void;
};

const EmbeddedFields = ({
  disabled,
  values,
  embeddedSelections,
  toggleEmbeddedSelection,
}: Props) => {
  const embeddedCellLabelRenderer = useMemo(
    () =>
      (
        row: AiLinkedFieldSuggestionValue["embeddedFields"][number],
        index?: number,
      ) => (
        <CellItem>
          {!disabled && index !== undefined ? (
            <Checkbox
              isDisabled={disabled}
              checked={embeddedSelections.has(index)}
              onChange={() => {
                toggleEmbeddedSelection(index);
              }}
            />
          ) : null}
          {row.name}
        </CellItem>
      ),
    [disabled, embeddedSelections, toggleEmbeddedSelection],
  );

  const columns = useMemo(
    () => [
      {
        label: "Embedded field",
        accessor: "",
        renderCell: embeddedCellLabelRenderer,
      },
      {
        label: "Suggested Value",
        accessor: "",
        renderCell: (
          row: AiLinkedFieldSuggestionValue["embeddedFields"][number],
        ) => (
          <CellItem>
            {Array.isArray(row.value)
              ? row.value.map((v, idx) => (
                  <React.Fragment key={`${v}-${idx}`}>
                    {v}
                    <br />
                  </React.Fragment>
                ))
              : row.value}
          </CellItem>
        ),
      },
    ],
    [embeddedCellLabelRenderer],
  );

  if (!values) return null;

  return (
    <EmbeddedTableContainer>
      <Table columns={columns} data={values} />
    </EmbeddedTableContainer>
  );
};

export default EmbeddedFields;
